import { z } from "zod";
import { runIdSchema, activeTaskRunRuntimeBackendSchema, taskIdSchema, taskRunCapabilitySchema, taskRunInteractionModeSchema, taskRunSourceSchema, sessionRoutingArchitectureSchema, taskAgentStepReasoningEnabledSchema, taskAgentCacheOptimizationEnabledSchema, } from "./primitives.js";
import { runModelConfigSchema } from "./model-config.js";
export const taskVisibilitySchema = z.enum(["private", "shared"]);
export const createTaskInputSchema = z.object({
    title: z.string().trim().min(1).max(200),
    organisationId: z.string().trim().min(1).optional(),
    visibility: taskVisibilitySchema.default("private"),
});
export const createTaskWithInitialRunInputSchema = z.object({
    prompt: z.string().trim().min(1),
    userId: z.string().trim().min(1),
    organisationId: z.string().trim().min(1).optional(),
    visibility: taskVisibilitySchema.default("private"),
    agentProfileSlug: z.string().trim().min(1).max(120).optional(),
    requestedSkillSlugs: z
        .array(z.string().trim().min(1).max(120))
        .max(32)
        .optional(),
    requestedPluginSlugs: z
        .array(z.string().trim().min(1).max(120))
        .max(32)
        .optional(),
    source: taskRunSourceSchema.default("web"),
    requestedCapabilities: z
        .array(taskRunCapabilitySchema)
        .min(1)
        .default(["readonly-data", "writeback"]),
    interactionMode: taskRunInteractionModeSchema.default("foreground"),
    runtimeBackend: activeTaskRunRuntimeBackendSchema.default("electric"),
    modelConfig: runModelConfigSchema.optional(),
    routingArchitecture: sessionRoutingArchitectureSchema.optional(),
    taskAgentStepReasoningEnabled: taskAgentStepReasoningEnabledSchema.optional(),
    taskAgentCacheOptimizationEnabled: taskAgentCacheOptimizationEnabledSchema.optional(),
    // AGE-18: opt-in multi-turn at task creation. Same semantics as
    // `createTaskRunInputSchema.priorRunId` — cross-tenant or unknown id
    // returns 404 problem+json from the HTTP-handler precheck.
    priorRunId: runIdSchema.optional(),
});
export const taskSummarySchema = z.object({
    id: taskIdSchema,
    title: z.string(),
    tenantSlug: z.string().optional(),
    organisationId: z.string().optional(),
    createdBy: z.string().optional(),
    visibility: taskVisibilitySchema.default("shared"),
    canEditVisibility: z.boolean().default(false),
    channelId: z.string().trim().min(1).optional(),
    channelName: z.string().trim().min(1).optional(),
    createdAt: z.number(),
    updatedAt: z.number(),
});
export const patchTaskInputSchema = z.object({
    taskId: taskIdSchema,
    visibility: taskVisibilitySchema,
});
export const createTaskResponseSchema = z.object({
    taskId: taskIdSchema,
});
export const patchTaskResponseSchema = z.object({
    task: taskSummarySchema,
});
export const createTaskWithInitialRunResponseSchema = z.object({
    taskId: taskIdSchema,
    runId: z.string().trim().min(1),
    sessionId: z.string().trim().min(1).optional(),
});
